import { fetchQuery, graphql } from "relay-runtime"
import { findChPatientByInternalIdQuery as QueryType } from "@/modules/patients/manage-duplicates/services/ch/__generated__/findChPatientByInternalIdQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query findChPatientByInternalIdQuery($internalId: Int!) {
    ch_patientByInternalId(patientInternalId: $internalId) {
      id
      firstName
      lastName
      gender
      displayId
      contactChannel
      country
      duplicatePatients {
        id
        firstName
        lastName
        gender
        displayId
        contactChannel
      }
    }
  }
`

const findChPatientByInternalId = (internalId: number) => {
  return fetchQuery<QueryType>(RelayEnvironment, query, { internalId }).toPromise()
}

export { findChPatientByInternalId }
